import React, { useState } from "react";
import { AngleDown } from "../IconTheme";

const DropdownGroup = ({ data, baseColor }) => {
	const [index, setIndex] = useState(0);
	const [open, setOpen] = useState(false);
	const activeIndex = data[index];
	return (
		<>
			<div className={`__dropdown ${baseColor ? "select-base" : ""}`}>
				<div className="__dropdown-active" onClick={() => setOpen(!open)}>
					{activeIndex.img && <img src={activeIndex.img} alt="" />}
					{activeIndex.img && <span>{activeIndex.name}</span>}
					<AngleDown />
				</div>
				<ul className={`__dropdown-menu ${open ? "active" : ""}`}>
					{data?.map(({ img, name, value }, i) => (
						<li
							key={i}
							onClick={() => {
								setIndex(i);
								setOpen(false);
							}}
							className={index === i ? "active" : ""}
						>
							{img && <img src={img} alt="name" />}
							{name && <span>{name}</span>}
						</li>
					))}
				</ul>
			</div>
		</>
	);
};

export default DropdownGroup;
